import localforage from 'localforage'

// Set up localforage to use IndexedDB
localforage.config({
  driver: localforage.INDEXEDDB, // Use IndexedDB as the driver
  name: 'QuickPass' // Name of your database
})

// Function to save JSON data to IndexedDB with the specified key
export const commitIndexedDB = async (key, jsonData) => {
  try {
    await localforage.setItem(key, jsonData)
    // console.log(`Data saved successfully under key '${key}'`)
  } catch (error) {
    console.error('Error saving data to IndexedDB:', error)
  }
}

// Function to retrieve JSON data from IndexedDB using the specified key
export const getIndexedDBData = async (key) => {
  try {
    const data = await localforage.getItem(key)
    if (data) {
      // console.log(`Data retrieved successfully from key '${key}'`)
      return data // Return the retrieved data
    } else {
      // console.log(`No data found for key '${key}'`)
      return null // Return null if no data exists
    }
  } catch (error) {
    console.error('Error retrieving data from IndexedDB:', error)
    return null // Return null in case of an error
  }
}
